module.exports = __webpack_public_path__ + "img/wx-kf.493bebdc.png";